export const HIGHLIGHT_PROPS = {
  highlightClassName: "text-turquoise-300 bg-transparent",
  autoEscape: true,
};
